"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLPPairTokenSymbol = exports.getLPPairTokenName = exports.getLPPoolName = exports.calculatePairRateWith18Decimals = exports.getPairTokenDecimals = void 0;
const DECIMALS_18 = 10n ** 18n;
const getPairTokenDecimals = () => {
    return 18n;
};
exports.getPairTokenDecimals = getPairTokenDecimals;
const calculatePairRateWith18Decimals = (reserveA, tokenDecimalsA, reserveB, tokenDecimalsB) => {
    const decimalsA = 10n ** tokenDecimalsA;
    const decimalsB = 10n ** tokenDecimalsB;
    const rateWith18Decimals = (reserveA * DECIMALS_18 * decimalsB) / reserveB / decimalsA;
    return rateWith18Decimals;
};
exports.calculatePairRateWith18Decimals = calculatePairRateWith18Decimals;
const lpSymbols = (tokenSymbolA, tokenSymbolB) => {
    return `${tokenSymbolA}-${tokenSymbolB}`;
};
const getLPPoolName = (uniswapV2Fork, tokenSymbolA, tokenSymbolB) => {
    return `${uniswapV2Fork} V2 ${lpSymbols(tokenSymbolA, tokenSymbolB)}`;
};
exports.getLPPoolName = getLPPoolName;
const getLPPairTokenName = (uniswapV2Fork, tokenSymbolA, tokenSymbolB) => {
    return `${uniswapV2Fork} ${lpSymbols(tokenSymbolA, tokenSymbolB)} LP`;
};
exports.getLPPairTokenName = getLPPairTokenName;
const getLPPairTokenSymbol = (tokenSymbolA, tokenSymbolB) => {
    return `${lpSymbols(tokenSymbolA, tokenSymbolB)} LP`;
};
exports.getLPPairTokenSymbol = getLPPairTokenSymbol;
